<template>
  <div>
    <p class="text-xs text-left info">
      Data collected will strictly be used for shipping and delivery purposes
      only.
    </p>
    <ul>
      <li v-for="{ title, link } in links" :key="title">
        <a :href="link" target="_blank" rel="noreferer">{{ title }} </a>

        <span v-if="title !== 'Contact'">
          <svg
            width="3"
            height="3"
            viewBox="0 0 3 3"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="1.5" cy="1.5" r="1.5" fill="#A09C95" />
          </svg>
        </span>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'FooterLinks',
  data: () => ({
    links: [
      {
        title: 'Gemnote Inc.',
        link: 'https://www.gemnote.com/'
      },
      {
        title: 'Privacy & Terms',
        link: 'https://www.gemnote.com/terms'
      },
      {
        title: 'Pricing',
        link: 'https://www.gemnote.com/pricing'
      },
      {
        title: 'Contact',
        link: 'mailto:support@gemnote.com '
      }
    ]
  })
}
</script>

<style lang="scss" scoped>
p.info {
  color: #a09c95;
}
ul {
  display: flex;
  gap: 0.75rem;

  li {
    display: flex;
    align-items: center;

    a {
      color: #a09c95;
      font-size: 0.625rem;
      font-weight: bold;
      text-decoration: none;
    }

    span {
      padding-left: 8px;
    }
  }
}
</style>
